export const SET_PRINT_RECEIPT_ORDER_ID = 'SET_PRINT_RECEIPT_ORDER_ID'
export const SET_PRINT_RECEIPT_PRINT_SETTINGS = 'SET_PRINT_RECEIPT_PRINT_SETTINGS'
